import { handleError } from 'globals/errors';
import { updateCurrentCustomer } from 'core_main/api/customers';
import { DescribeCustomerParameters } from './types';
import {
  formatAttributes,
  createDescribeCustomerCallbackResponse,
} from './helpers';

export const describeCustomer = (
  parameters: DescribeCustomerParameters,
  cb,
) => {
  const formattedAttributes = formatAttributes(parameters.attributes);

  const requestParams = {
    attributes: formattedAttributes,
    custom: parameters.customAttributes,
  };

  return updateCurrentCustomer(requestParams)
    .then((res) => {
      const callbackResponse = createDescribeCustomerCallbackResponse(res);

      if (typeof cb === 'function') cb(callbackResponse);
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      handleError(error, { message: `Failed to describe customer:` });
    });
};
